import { OrganizationStatus } from '@shared/model/organization';
import { StatusTagData } from '../ui/card-organization/types';

export const STATUS_MAP: Record<OrganizationStatus, StatusTagData> = {
    active: { variant: 'green', text: 'Активна' },
    disabled: { variant: 'grey', text: 'Заблокирована' },
};
